<template>
  <div class="cancel_order"  v-show="is_show">
    <div class="cancel_dialog" >
      <div v-if="is_logout" class="logout_title">
        <p>当前账号<span class="red">{{user_real_phone}}</span></p>
          <p>{{ title }}</p>
      </div>
      <div v-else name="header" class="common_title">
        <h3 v-if="title">{{title}}</h3>
        <p v-if="subTitle">{{subTitle}}</p>
      </div>
      <div class="common_content">
        <slot></slot>
      </div>
      <!-- 底部button -->
      <div name="footer" class="common_btn">
        <div @click="cancel" :class="{common_btn_left: colorType == 'left'}">{{leftContent}}</div>
        <div @click="confirm" :class="{common_btn_right: colorType == 'left'}">{{rightContent}}</div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  export default {
    name: 'confirm',
    data () {
      return {}
    },
    computed: {
      ...mapGetters({
        user_real_phone: 'user_phone'
      })
    },
    props: {
      is_show: {
        type: Boolean,
        default: true
      },
      leftContent: String,
      rightContent: String,
      title: String,
      subTitle: String,
      colorType: {
        type: String,
        default: 'left'
      },
      is_logout: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      // 再考虑
      cancel: function () {
        this.$emit('cancel')
      },
      confirm () {
        // this.own_show = false
        this.$emit('confirm')
      }
    }
  }
</script>
<style type="text/css" lang="scss">
  @import '../assets/scss/base.scss';
  .cancel_order {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,0.4);
    z-index:1000;
    top: 0;
    padding:0 pxToRem(70px);
    box-sizing: border-box;
    .red {
      color: $opt-color;
    }
    .cancel_dialog {
      position: relative;
      margin: 0 auto;
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
      padding-top: pxToRem(58px);
      @include box_shadow;
      // 公共title button样式
      .common_title {
        h3 {
          font-size: 16px;
          text-align: center;
          color: $black;
        }
        p {
          margin-top: pxToRem(36px);
          text-align: center;
          font-size: 14px;
          color: $gray;
        }
      }
      .logout_title {
        p {
          margin-bottom: pxToRem(36px);
        }
        font-size: 14px;
        text-align: center;
        color: $black;
      }
      .common_btn {
        width: 100%;
        height: pxToRem(105px);
        line-height: pxToRem(105px);
        display: flex;
        border-top: 1px solid $gray-light;
        font-size: 14px;
        color: $black;
        div:nth-child(1) {
          width: 50%;
          text-align: center;
          border-right:1px solid $gray-light;
          &:hover {
            color: #f2f2f2;
          }
        }
        div:nth-child(2) {
          width: 50%;
          text-align: center;
          color: $red;
          &:hover {
            background: #f2f2f2;
          }
        }
       div:nth-child(1).common_btn_left {
          color: $opt-color;
        }
       div:nth-child(2).common_btn_right {
          color: $black;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Confirm.vue?bf5ed46e